// Immutable public copies of Glide-owned integration icons.
const objects = new Map<string, string>([
    [
        "image/upload/t_integration-logo/plugins/ElevenLabs.png",
        "6b656fcfbc5ee8930c243c017aa95db5e47739279170c731b6aaba8bc468549d/9729847eafe485b32ac237598a0c6c76.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/Gmail.png",
        "c117f57c85a808ca5213cf7281a3b2359f3d98df03ec0a86fe4920645fe61a6f/67f797e470e58ee3a14065db9920aa34.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/PostHog.png",
        "683fde6f73cf87b7e6363dcc125ff001ef5e604e71a9b47798c49d8af3cb71cd/df7f140b40e55c515278bf0d612da131.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/Zenrows.png",
        "93ef78d874e6c058763e00f1f33d637b0b087f70b0c5af58894f0067a0719d74/d3a8ea3d76ffa651cdbcc08623812029.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/airtable.png",
        "e5f52d769f70278c48c8d93957591730810438cc1af3375df25e816087d6ae11/b783cea8e55b7d1aab478fb18545fe9d.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/asana.png",
        "28e42bc635c104136718750cf3dcfe1e4e4a3d57fb73f24913949516485ed7a4/841ea29684fc57d09f6e3a86f9277975.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/azure.png",
        "35bad36171b3df4cd077b48eaf80f2de0ef7946ad0927edb93a7f99eaa03a1bc/5d17d07b802c97f85a76bd4279bdba7f.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/clearbit.png",
        "42712f1af56f63a6ee67bcc972ca09f318e9455d5a57fdf2d21c85a6018c1f12/762c2e4e5469132f12db27a6eeca4010.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/cloud_sql.png",
        "598a055eb858a3e24cd098418339b684fe26c510d6223e193e116381698881fb/147a63c1b863936d80b3c4e1029d494e.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/csv.png",
        "c09bc07fc5483e9bae96e504b340a110eb1fadf23e4e83b4aeea039d33a46c38/4707f7d6bbfcfb598707351289bf76ab.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/data-structure.png",
        "afa26926714c6f1e3b6a86a89053b6174a46850607bbc0fb01f42c4dec0826c9/191bcbfafd2ded1a41a050cbe05ca3b9.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/device-features.png",
        "d5e44448e11c2fed21d84b57863dcfe859c19d17295893ce07a88ff58b0b934e/db12536bc5620559baa6f045e7a0bd32.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/discord.png",
        "c8e99d17e4e89dd128b7ccc9184c9779855d8301552e6a83933ae7261b4e01f4/8575830da1a5e2cc7f4aa7e714c6893b.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/docsautomator.png",
        "93e8b520a5316490d321af8dc77b48e3e4fa113e15c9e49104abf67922019ada/ed3724b5e2476d71e2c1a95b91cbc9ba.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/docusign.png",
        "d20101bc4455cca8be5b0696cda363e075c36377c34f0bdceb6cd1a38aca30d3/d10d71f649eb54dd12ca29c2ac11359a.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/excel.png",
        "5fc9e462e00c7d685b2f916c9700a2b169e3fc906c09b49a35bc93bdb3c085bf/652ce847479661e3e4bc6f29393e444c.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/ganalytics.png",
        "48a2eb10ee81dbeb052e80b6ecffad853e211b7dc02fd1a03db9ac0975019a57/c80f29efaa486108b00f51f73cf2e724.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/giphy.png",
        "d65e399462e49fc4013e26b87d6f69fdae7b68b46119904f8426bf4d37de3d7d/e90fb4edaa0c5153920f311effdf58f6.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/github.png",
        "52281728a870c33bc873bbf20e430005434ead3504737870b8e672612b0d1437/3a58e47aab84085acb42e0f25b7b8d7a.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/glide-webhook.png",
        "ced61433c2f86e0b59e2a6e3932c32ceaed1aaad389e0f855ea691dbe295f5b3/ed4af635f57109e83e3934f4d9d2e7f4.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/glide.png",
        "35f1cfef8a12e0392c3104a5b258e9be6d224a96e20216267180bf1bb500c3ce/bfb84618d915147958c09d2b45a106e3.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/google-calendar.png",
        "bdb5e4ac782b94768cc7cf58aa842122771d2dbac2e5c873ef7d63bc775c2b73/4a4e85885d0da52506383eb82f0e7f1e.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/google-cloud.png",
        "2be8b81f9b632be7703863a867233fb988ab2551a9c070eb12ecc50d6a61be40/419763a27b4ceea89f1fdb64f250c090.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/googlemaps.png",
        "7a7679242533a802b75a54ea6261b5337c9b4a5bd165d56d9c76984758fa0617/4423782695ecd9b5b8408bbfbc13a09c.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/gravatar.png",
        "9cbf8b3c0752e3ae2c7651b3da8e1527a0e55da15543118d95837d480f495921/325f9ce37f2876d9c0b3ed2d2a49cba1.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/gtag.png",
        "9cd0b766c055ef81e5a85d25e7b278a8b3f4a662deb7deec0fa9908688da0c08/40110eb10dd0cca20e1a0aaacf3f137d.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/hubspot.png",
        "86a1286cf86c109bad01f769f7ee360129586e467a9b716f814a469bc58263a8/14edfe21572434453e2e2fa6db637da6.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/ifttt.png",
        "6cf4d6afc500df3b93f6f365fc41029821283bdb0254e1a1295a63fc413d827e/25a704eb5faa9842d8e1d2b130fe5b7f.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/image-editor.png",
        "12e7b54dc7d8593729ee2bb9e16b2a133743922c1cc89b9570d77dc86cbf723d/186b1f11c10040fc8e7c796ff635671c.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/intercom.png",
        "fda846bc68705de7acb099829e5f01e7d39547208f5803eb2e23ecd1c5ec1f28/f83a013fab75068ab0ede9f6addb1909.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/koala.png",
        "ab34ebf796a487ac8661a4f816a79fab1aa8302cabfb90aac9d33589106d6859/2a9d81bd952a9fb2e8b71f226ca5e7e5.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/make.png",
        "3119335d6e3ed89aa14565a9ad814f94724f7b6cde64a2e32dee0fc4ca9af538/a8d10ae0b2b30875bb6c86ff38e7f9e1.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/meta.png",
        "ccab82cd05f961a8e92f52a0e85904e5f7cb808f84e7583beec64ac185024be7/5dc657034252486c22f0b0352010a152.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/mixpanel.png",
        "5d26ef20f1982e15ed949034a0b063fc859249279a8136a0c127c711eec0e61b/aac93ddb692cdac8fed82d09f88ca2e3.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/ms-outlook.png",
        "b74c31a188e917c2af042fba33b41ae39b6be3c7dd4d88fab57094ce2b3cfb82/c25bcbba0fcd2483c8531c2c245e3185.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/ms-teams.png",
        "a58a5850581646efce2e8f33d203e6b52859f0e2b305f4e2e0cea3db6ee264e1/1e6a2b18d3710a50ebb51c10bcca7c38.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/mssql.png",
        "8b85a361b6000bf2c6b01a6b9aee7eed933db82026074a9eb22ad102cb8a6c00/21edfb70edad5ddc4226b3a165762483.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/mysql.png",
        "a8f094abdf400a9e6c02c6704d887853a133edf5e9c5edb6072ef1e186d1cf65/09325b0cd5df7e26120d14efc900b9f7.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/openai.png",
        "e56cabbf8d224d8215ddf88d1fa13d2900886e29e60566ad347ddb0c26259369/c0da98578a050997e32e44cdf40aee31.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/opengraph.png",
        "b989c2258ef93cec7edc2d0c07bbab693c59eb20167e4458c8d00da724a4da0c/067d596b08932020c503eed9d278f3a4.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/paypal.png",
        "c3c6f06e59ca626dd7d40b73c832b1ce505d6057cf618cf1e210c76e0a11cae2/cb76deae4204d608baf68ae4e6a2529e.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/pdfmonkey.png",
        "f778b5db400b761bb8dbadaa91c3b8664d59cf8f2b5cb00bd6e460ab713d75aa/d38d50409374917653f2b4577c5e7db5.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/pexels.png",
        "9774a650cea1399d2e2ff5f0a31532092c5a189a566e62d4507bd809d86572e9/9aac1dad1e48d10046c5c87bf584d755.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/pinecone.png",
        "273a42c985a75589ffdd637ba6a62197f45b0d4ed5843b27f6fee7e12c987c44/7c29359b765ac1169346c8cebee7543c.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/postgresql.png",
        "c35897e46c02cd0f7c7a406c9080590d5b9fe6c8446a30d3e6b23618b96f28f3/24bfbaaa0592832db146f9a346a4555c.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/push-notifications.png",
        "9833e4da1a68f6e968dbf2b51305c6e578d0a8da9ab4e9f6d135e01bc334db46/480ca044d16ebbdbee3818cbd5764a88.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/quickbooks.png",
        "a24b28ac476a44dc5a51ece9762ebf0e03657f9842a9e3ecfe07ef9263dc134f/e7d3a3f67dc3a25ae5a2e1db8e6d5ff5.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/radar.png",
        "4fa764b42379bdd8228c88ff7f194eef57da66df83b360123a003bda2baaa616/f654ea4498773751b4f55c68c17eddc1.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/replicate.png",
        "0fc952032cbe6d0b9428355180e5c29f2ba96fa5eeb647d1202ea95627413706/62b22cbc2a6f2a113a555b3eafeaa458.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/salesforce.png",
        "a219f7fdc72eeb5be42888e30ef963d2a6a33d6136554f01342c8100d565e892/bd3505b16f4a05a96440c44b43f76172.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/segment.png",
        "82418c6788b3c3a190e4b73dbcfef75af0353974f96f4a29b1000f02d44ec0a0/5a46535f49200147100ff0d18479b1d8.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/short.png",
        "783325c604eaeff31dc5cbc5015d261552fc057ba22933ca5028c4d53c33d918/0148b55763ff842fffaaa52e24fd5b64.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/slack.png",
        "490c20ad9a3e01b1a7f2220c7d73422fccb463d350f3923ddf15df50a56f29e9/47f3f8723af46ea9bc2742cbf4333cd5.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/st-sso.png",
        "76b4e56042f343a86062a39fc77c02fa6913bda6a87aa4ce20f4a0ae1ec042a2/4cdc25b0c3f2c8c72b352178729e60df.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/stripe.png",
        "292e3dfe8413783194388d022eeefe61d1e4493e2b30907ec8853b1ae759cca5/f648553523ec2f1a1b132dc45d459a1c.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/twilio.png",
        "c88829a66769ec6fdaec72f3bc6c4efa26582b2c867fc9c128883611bd9ade1b/cef95298fa156a2fdcdd9a9b6c5ad4b0.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/urlbox.png",
        "eae85765352bac8744ae4d4f539093d9ecaf327e330d777bb54e4871c60d46f5/83a626db051a9f8e8016bc5f29249831.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/xml.png",
        "8527bfd90eba69a12deed233aa4e18d9820d588e98196ecb66ca6717a3abed9a/232fd33b85836cb29515c78c2178922a.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/yelp.png",
        "ea0dc1df2f7e08faa51b1fd08b7814d93cdf868a1742302ee3cd0442dfb05e08/5848e796709dd892b59bcc02ec11a689.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/zapier.png",
        "6ace51ceb6a291bf509f1d39d11301eb849c5d79a85574ab5e06eef2aefe9ad1/3767f1f6190eaf6012822bbe4e015589.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/zendesk.png",
        "b08250d882e2fa915b98daaf092707df76fd46852f7626c5a88aad386a9c7aa4/a38feec4a1337800ce1ff57dc3a97001.png",
    ],
    [
        "image/upload/t_integration-logo/plugins/zoom.png",
        "245c9c25a40a5d3c3b0858ee7f3d57ded499e4ee3dbd4367734af95b9918ccae/27ea263d14c366a6f8134481565418ec.png",
    ],
    [
        "image/upload/t_integration-logo/v1733672400/plugins/openrouter.png",
        "544342d59df50bb2a13ae0360c038a2b06b0b2499fe23f95db4a7c43b5681424/2001de77c1e0457e825a0243935ebb3f.png",
    ],
    [
        "image/upload/t_integration-logo/v1739580435/plugins/gemini.png",
        "f7cb75bdc8fcd694e19dd8bc01df43142a8c82418a8a67153a178245f076cfbc/e108906932943fae66c2d6bd6156e3ba.png",
    ],
    [
        "image/upload/t_integration-logo/v1760574008/plugins/claude.png",
        "5bd981cbe5d3d56a7669092caac96573947282bcf0ce1a8fc7ee86ff9ad9e132/f0a3b0254b8763a8891f8662b2afd6ca.png",
    ],
]);

const publicURLPrefix = "https://storage.googleapis.com/glideapps-dotcom/preserved-cloudinary/integration-logos/";
const publicURLs = new Set([...objects.values()].map(object => `${publicURLPrefix}${object}`));

export function isIntegrationIconAssetURL(source: string): boolean {
    return publicURLs.has(source);
}

export function integrationIconAssetURL(path: string): string | undefined {
    const object = objects.get(path);
    return object === undefined ? undefined : `${publicURLPrefix}${object}`;
}
